<script setup lang="ts">
import { CREDIT_COMPARISON_COLUMNS, CREDIT_COMPARISON_ROWS } from '../content';
import { CreditSectionTitle } from '../CreditSectionTitle';
</script>

<template>
	<section class="px-6 py-26">
		<div class="mx-auto max-w-[1240px]">
			<div class="max-w-[720px]">
				<CreditSectionTitle
					>Financiamento, consórcio ou CGI?</CreditSectionTitle
				>
				<p class="mt-4.5 mb-0 text-[18px] leading-[1.6] text-[#A3A3A3]">
					Um resumo honesto para você decidir. Na dúvida, o especialista compara
					os três para o seu caso.
				</p>
			</div>
			<div class="mt-11 overflow-x-auto rounded-xs border border-[#262626]">
				<table
					class="w-full min-w-[760px] border-collapse text-[15px] leading-[1.5]"
				>
					<thead>
						<tr class="bg-[#1A1A1A] text-left text-[#FAFAFA]">
							<th scope="col" class="w-[22%] px-5.5 py-4.5 font-medium" />
							<th
								v-for="column in CREDIT_COMPARISON_COLUMNS"
								:key="column"
								scope="col"
								class="px-5.5 py-4.5 text-left font-medium"
							>
								{{ column }}
							</th>
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="(row, index) in CREDIT_COMPARISON_ROWS"
							:key="row.label"
							:class="[
								'border-t border-[#262626]',
								{ 'bg-[#0A0A0A]': index % 2 === 1 }
							]"
						>
							<th
								scope="row"
								class="px-5.5 py-4.5 text-left font-medium text-[#A3A3A3]"
							>
								{{ row.label }}
							</th>
							<td
								v-for="(value, column) in row.values"
								:key="column"
								class="px-5.5 py-4.5"
							>
								{{ value }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</section>
</template>
